export class TokenUser {
    constructor() {
        this.roles = [];
    }

    username?: string;
    password?: string;
    role?: string;
    roles: string[];
    exp?: number;
}